import styled from 'styled-components';

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
`;

export const Title = styled.span`
  font-weight: 600;
  font-size: 15px;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  color: inherit;
`;

export const ParentSection = styled.div`
  padding: 12px 16px;
  border-bottom: 1px solid rgba(0,0,0,0.08);
  overflow-x: hidden;
`;

export const LoadEarlierButton = styled.button`
  display: block;
  margin: 0 auto 8px;
  padding: 4px 12px;
  border: none;
  border-radius: 12px;
  background: rgba(0,0,0,0.05);
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;

  &:hover {
    background: rgba(0,0,0,0.09);
  }
`;

export const RepliesSection = styled.div`
  padding: 8px 16px;
  max-height: 50vh;
  overflow-x: hidden;
  overflow-y: auto;
`;
